import { render, staticRenderFns } from "./Loginsuccess.vue?vue&type=template&id=78540c12&scoped=true"
import script from "./Loginsuccess.vue?vue&type=script&lang=js"
export * from "./Loginsuccess.vue?vue&type=script&lang=js"
import style0 from "./Loginsuccess.vue?vue&type=style&index=0&id=78540c12&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78540c12",
  null
  
)

export default component.exports